// ABOUTME: The one empty state the lists share: two quiet lines, centred, in the place a list would have been.
import Box from '@mui/material/Box';
import { LightGrayLabel } from 'components/labels';

interface Props {
  body1: string;
  body2: string;
}

export const EmptyState = ({ body1, body2 }: Props) => (
  <Box data-testid="empty-state" sx={{ textAlign: 'center', p: 5, mt: 10 }}>
    <LightGrayLabel>{body1}</LightGrayLabel>
    <br />
    <LightGrayLabel>{body2}</LightGrayLabel>
  </Box>
);
